import { BomHierarchyGenerator, BomNode } from "./bom-hierarchy-generator";
import { BomRecordsForParents } from "./bom-records";
import { PurchasingPriorities } from "./purchasing-priorities";

export function getSalesOrderBomHierarchy(
  bomRecordsForSalesOrder: BomRecordsForParents,
  purchasingPriorities: PurchasingPriorities,
): BomNode[] {
  return new BomHierarchyGenerator(purchasingPriorities).generate(bomRecordsForSalesOrder);
}
